import { render, staticRenderFns } from "./StatementsSection.vue?vue&type=template&id=2bca9ca4&"
import script from "./StatementsSection.vue?vue&type=script&lang=js&"
export * from "./StatementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports